import ContactMailIcon from '@mui/icons-material/ContactMail';
import { Box, Button, Stack } from '@mui/material';
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import {
  ApiFailModal,
  useSuccessRedirect,
} from '../../../components/modal/ApiResultHandler';
import { PrimaryLoadingButton } from '../../../components/style/ButtonStyle';
import { LoginBackground } from '../../../components/style/CommonStyle';
import { useAxios } from '../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../hooks/useYupValidationResolver';
import { CHANGE_TOKENS } from '../../../store/authSlice';
import ExOne from '../../static/images/bg.png';
import { LoginInput } from '../MapPage/FacilityFormPage/CommonForm';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function LoginFormPage() {
  const [postTokenResult, postToken] = useAxios({
    method: 'POST',
    url: '/api/v1/auth/login',
  });

  const resolver = useYupValidationResolver(
    Yup.object().shape({
      id: Yup.string().required('아이디를 입력해주세요').max(100, '100자 이하'),
      password: Yup.string()
        .required('비밀번호를 입력해주세요')
        .max(200, '200자 이하'),
    }),
  );
  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      id: '',
      password: '',
    },
    shouldUnregister: false,
  });

  const handleSubmit = form.handleSubmit(values => {
    const payload = {
      id: _.trim(values.id),
      password: _.trim(values.password),
    };
    postToken({ data: payload });
  });

  const dispatch = useDispatch();
  useSuccessRedirect(postTokenResult, '/map', {
    onSuccess: (postTokenResult: any) => {
      dispatch({
        type: CHANGE_TOKENS,
        payload: {
          accessToken: _.get(postTokenResult, 'data.accessToken'),
          refreshToken: _.get(postTokenResult, 'data.refreshToken'),
        },
      });
    },
    successCode: 200,
  });
  return (
    <LoginBackground
      sx={{
        backgroundImage: `url(${ExOne})`,
      }}
    >
      <Stack
        bgcolor="#fff"
        sx={{
          maxWidth: '620px',
          height: 'fit-content',
          position: 'absolute',
          margin: { xs: 'auto 40px', sm: 'auto' },
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          borderRadius: '20px',
        }}
      >
        <Stack spacing={{ xs: 4, md: 5 }} p={{ xs: 4, sm: 5, md: 8, lg: 10 }}>
          <Stack
            alignItems="center"
            sx={{ pb: { sm: 3 }, width: 223, margin: 'auto' }}
          >
            <img
              src={require('../../../app/static/images/itl_logo.png')}
              alt="logo"
            />
          </Stack>
          <Stack sx={{ flex: 1 }}>
            <LoginInput
              form={form}
              isRequired={true}
              label="아이디"
              fieldPath="id"
              placeholder="아이디를 입력하세요."
            />
          </Stack>
          <Stack sx={{ flex: 1 }}>
            <LoginInput
              type="password"
              form={form}
              isRequired={true}
              label="비밀번호"
              fieldPath="password"
              placeholder="비밀번호를 입력하세요."
            />
          </Stack>
          <Stack spacing={3}>
            <PrimaryLoadingButton
              sx={{ py: 2 }}
              onClick={handleSubmit}
              loading={postTokenResult.loading}
            >
              로그인
            </PrimaryLoadingButton>
            <InquiryButton />
          </Stack>
          <ApiFailModal
            apiResult={postTokenResult}
            failTitle="로그인 실패"
            failContent="아이디 또는 비밀번호가 일치하지 않습니다."
          />
        </Stack>
      </Stack>
    </LoginBackground>
  );
}

function InquiryButton() {
  const [email, setEmail] = useState('');

  useEffect(() => {
    axios
      .get('/api/v1/users/manager/email')
      .then(response => {
        const emailData = response.data?.email;
        setEmail(emailData);
      })
      .catch(error => {
        console.error('Error fetching email data:', error);
      });
  }, []);

  return (
    <Stack direction="row" justifyContent="space-between">
      <Box sx={{ w: 1 }} />
      <a href={`mailto:${email}`}>
        <Button
          variant="text"
          startIcon={<ContactMailIcon fontSize="small" />}
          sx={{ width: 'fit-content' }}
        >
          관리자에게 문의하기
        </Button>
      </a>
    </Stack>
  );
}
